import { render, staticRenderFns } from "./WhiteLabelModule.vue?vue&type=template&id=3cf65e4d&"
import script from "./WhiteLabelModule.vue?vue&type=script&lang=js&"
export * from "./WhiteLabelModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports